
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M23.67 49.48H1.34V4.7h48.15v24.34M10.83.47v8.45M20.57.47v8.45M30.3.47v8.45M40.03.47v8.45M1.88 16.48h47.07M55.32 42.19a16.62 16.62 0 10-1 5.7"}}),_c('path',{attrs:{"d":"M42.58 38.13a3.79 3.79 0 00-4-3.62c-2.15 0-4 1.34-4 3.48a3.24 3.24 0 001.23 2.77 11.08 11.08 0 003.84 1.47 3.75 3.75 0 01-.77 7.46c-2.15 0-4.3-1.47-4.3-3.62M38.69 52.55v-20.9M59.06 36.51l-3.71 5.34-5.34-3.71","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    